import { render, staticRenderFns } from "./EligibilityResult.vue?vue&type=template&id=154cc319&scoped=true"
import script from "./EligibilityResult.vue?vue&type=script&lang=js"
export * from "./EligibilityResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154cc319",
  null
  
)

export default component.exports